import SmallTalkGame from '../components/SmallTalkGame';

const LyricsPracticeSmallTalk = () => (
    <div className="app lyrics-game-page">
        <main aria-label="Small Talk 응원법·떼창 연습 게임"><SmallTalkGame /></main>
    </div>
);

export default LyricsPracticeSmallTalk;
